import { createEntityAdapter } from "@reduxjs/toolkit";
import { apiSlice } from "../../app/api/apiSlice";

const libraryTaskAdapter = createEntityAdapter({
  selectId: (task) => task.id,
});

const libraryTaskInitialState = libraryTaskAdapter.getInitialState();

export const taskLibrarySlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getLibraryTasks: builder.query({
      query: () => `/tasks`,
      transformResponse: (responseData) => {
        const loadedLibraryTasks = responseData;
        return libraryTaskAdapter.setAll(
          libraryTaskInitialState,
          loadedLibraryTasks
        );
      },
      providesTags: (result, error, arg) => {
        if (error) {
          return [{ type: "LibraryTasks", id: "ERROR" }];
        }
        return [
          { type: "LibraryTasks", id: "LIST" },
          ...(result?.ids || []).map((id) => ({ type: "LibraryTasks", id })),
        ];
      },
    }),

    getTaskTypes: builder.query({
      query: () => `/tasks/types`,
    }),

    createLibraryTask: builder.mutation({
      query: (data) => ({
        url: `/tasks`,
        method: "POST",
        body: {
          ...data,
        },
      }),
      invalidatesTags: [{ type: "LibraryTasks", id: "LIST" }],
    }),

    updateLibraryTask: builder.mutation({
      query: (data) => ({
        url: `/tasks/${data.id}`,
        method: "PUT",
        body: {
          ...data?.data,
        },
      }),
      invalidatesTags: [{ type: "LibraryTasks", id: "LIST" }],
    }),

    deleteLibraryTask: builder.mutation({
      query: (id) => ({
        url: `/tasks/${id}`,
        method: "DELETE",
      }),
      invalidatesTags: [{ type: "LibraryTasks", id: "LIST" }],
    }),
  }),
});
export const {
  useGetTaskTypesQuery,
  useCreateLibraryTaskMutation,
  useGetLibraryTasksQuery,
  useUpdateLibraryTaskMutation,
  useDeleteLibraryTaskMutation,
} = taskLibrarySlice;
